import React from "react";
import { Reorder } from 'framer-motion';
import { matchPhrases } from "../../../utils/utilities";

import Conditional from "../../common/conditional";
import CustomNewItem from '../custom-general/custom-new-item';
import HardnessEquipmentForm, { HardnessEquipment } from "../../forms/custom-hardness/hardnessEquipmentForm";
import ItemCount from '../../blocks/item-count';
import ReorderItem from '../../common/reorderItem';

import toastService from "../../../services/toastService";

interface Props {
    hardnessEquipmentItems: HardnessEquipment[];
    onChangeHardnessEquipmentItems: (items: HardnessEquipment[]) => void;
}

const HardnessEquipmentItems: React.FC<Props> = ({ hardnessEquipmentItems, onChangeHardnessEquipmentItems }) => {
    const handleAddItem = (item: HardnessEquipment) => {
        const itemMatch = hardnessEquipmentItems.find((analysisItem) => matchPhrases(analysisItem.equipmentName, item.equipmentName));
        if (itemMatch) return toastService.error(`Equipment ${item.equipmentName} already exists!`);

        const newAnalysisItems = [...hardnessEquipmentItems, item];
        onChangeHardnessEquipmentItems(newAnalysisItems);
    };
   
    const handleEditItem = (baseItem: HardnessEquipment, updatedItem: HardnessEquipment) => {
        const newAnalysisItems = hardnessEquipmentItems.map((analysis) => analysis.equipmentName === baseItem.equipmentName ? updatedItem : analysis);
        onChangeHardnessEquipmentItems(newAnalysisItems);
    };

    return ( 
        <>
            <Conditional isVisible={false}>
                <ItemCount count={hardnessEquipmentItems.length} label='Hardness Equipment' />
                            
                <CustomNewItem label='Add New Hardness Equipment'>
                    <HardnessEquipmentForm onSave={handleAddItem} />
                </CustomNewItem>
            </Conditional>
            
            <Reorder.Group className="list-unstyled" values={hardnessEquipmentItems} onReorder={onChangeHardnessEquipmentItems}>
                {hardnessEquipmentItems.map((item) => (
                    <ReorderItem key={item.equipmentName} value={item}>
                        <HardnessEquipmentForm
                            initialItem={item}
                            onSave={(updated: HardnessEquipment) => handleEditItem(item, updated)}
                        />
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default HardnessEquipmentItems;